<template>
    <div v-if="visibleCategories.length" class="mb-2 lg:hidden">
        <div class="flex w-full gap-x-3 overflow-x-auto" style="max-width: 100%">
            <CategoryLink
                v-for="child in visibleCategories"
                :key="child.categoryPath || child.id || child.resolvedUrl"
                :to="child.to ?? '/' + child.resolvedUrl"
                :category-id="child.id"
                :category-path="child.categoryPath"
                :search="search"
                observe-parent
                class="btn w-fit shrink-0 cursor-pointer rounded-full border border-green-550 border-2 bg-green-300 !px-10 !py-3 text-center [&:not([aria-disabled=true]):hover]:bg-green-500 aria-disabled:order-last">
                {{ child.translated.name }}
            </CategoryLink>
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { RouteLocationRaw } from 'vue-router';

    const props = defineProps<{
        categories: Array<{
            id?: string;
            categoryPath?: string;
            resolvedUrl?: string | null;
            to?: RouteLocationRaw;
            translated: { name: string };
            customFields?: { nd_tweakwise_hide_in_category_tree?: boolean } | null;
        }>;
        search?: string;
    }>();

    const visibleCategories = computed(() =>
        props.categories.filter(category => !category.customFields?.nd_tweakwise_hide_in_category_tree),
    );
</script>
